import React, { useEffect, useState } from 'react';
import { ProgressBar, label, } from "react-bootstrap";

const ARBProgressBar = ({ value, message = "Please Wait .." }) => {
    // Calculate the percentage of progress
    const percentage = value;
    return (
        <>
        <div style={{
                position: 'absolute',
                top: '0',
                zIndex: '88881',
                width: '100%',
                left: '0',
                height: '100%',
                opacity: '0.5',
                backgroundColor: 'black'
            }}></div>
        <div style={{
                position: 'fixed',
                top: '27%',
                zIndex: '88883',
                width: 'auto',
                left: '30%',
                height: '35px',
                fontSize: '20px',
                color: 'black'
            }}>{message} {`${percentage}%`}</div>        
        <ProgressBar
            style={{
                position: 'fixed',
                top: '27%',
                zIndex: '88882',
                width: '42%',
                left: '29%',
                height: '35px',
                fontSize: '20px',
                color: 'black'
            }}
            now={percentage} animated={true} variant='warning' />
        </>
    );
};

export default ARBProgressBar;
